export default __webpack_public_path__ + "f639ce947dab766e93f9cd049b3e99d1.svg";